/***
 * 创建人：李珊
 * 时间：2020-12-12
 * 描述：素材库——素材管理——抓取源管理：查看详情操作
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
declare var $: any;
@Component({
  selector: 'app-grab-source-view',
  templateUrl: './grab-source-view.component.html',
  styleUrls: ['./grab-source-view.component.css']
})
export class GrabSourceViewComponent implements OnInit {
  
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  //数据绑定对象
  grabSourceModel: any = { }; 
  constructor(
    private box: SwMassageBoxService,  //消息提示框
    private service: KmsService,   //请求服务
  ) { 

  }

  ngOnInit() {
    this.clickLoca(this.param["selectedData"]);
  }
  //抓取源点击新增 或者 修改
  clickLoca(selectedData: any) {
    // 查询抓取源信息
    this.service.queryCrawlWebsiteById(selectedData.websiteId).subscribe(
      data => {
        if (data["code"] == '200') {
          this.grabSourceModel = data["data"];
        }
      }
    )
  }
}

